import styled, {css} from 'styled-components';

export const HeaderCanelMainWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    flex-direction: column;
    box-shadow: 0 -1px 4px 1px rgba(74, 74, 74, 0.2);
  `
);

export const HeaderCancelOuterWrap = styled.div(
  props => `
    width:100%;
    display: flex;
    padding: ${props.theme.spacing.large.l20} ${props.theme.spacing.large.l30};
  `
)

export const HeaderCancelImgWrap = styled.div(
  props => `
    width:6rem;
    height:6rem;
    margin-right: ${props.theme.spacing.large.l15}
  `
);

export const HeaderCancelInfoWrap = styled.div(
  props => `
    width:90%;
    display: flex;
    flex-direction: column;
  `
);

export const HeaderCancelText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font22};
        color: ${props.theme.colors.black.base};
        font-weight: ${props.theme.font.fontWeight.black};
    `
);

export const HeaderCancelInfoInnerWrap = styled.div(
    props => `
        width:100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    `
);

export const HeaderCancelHtlInfo = styled.p(
    props => `
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.grey.base};
    `
);

export const HeaderCancelHtlDateInfoWrap = styled.div(
    props => `
        display: flex;
        align-self: flex-end;
        align-items: flex-end;
        justify-content:center;
    `
);

export const HeaderCacnelHtlDateImg = styled.div(
    props => `
        width:2.4rem;
        height: 2.4rem;
        margin-right:  ${props.theme.spacing.base};
    `
);

export const HeaderCancelDateText = styled.p(
    props => `
        font-size: ${props.theme.font.large.font16};
        color: ${props.theme.colors.grey.base};
    `
);


export const HeaderStepBlock = styled.div(
    props => `
        width:100%;
        height: 4rem;
        display: flex;
        border-top: 1px solid ${props.theme.colors.grey.lighte7};
        align-items: center;
        
    `
);

export const HeaderStepFirstBlock = styled.div(
    props => `
      display: flex;
      align-items: center;
      padding: 0 ${props.theme.spacing.large.l15};
      height: 4rem;
      background-color: ${props.isActive ? props.theme.colors.yellow.lightfe : ''};
      height: 3.9rem;
      border-radius: 0 0 0 ${props.theme.misc.borderRadius.base};
      cursor: pointer;
    `
);

export const HeaderStepWrap = styled.p(
    props => `
      width:2rem;
      height: 2rem;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: ${props.theme.misc.borderRadius.round};
      font-size: ${props.theme.font.small.font11};
      border: ${props.isActive ? 'none' : `1px solid ${props.theme.colors.grey.lighte7}`};
      background-color: ${props.isActive ? props.theme.colors.grey.base: props.theme.colors.grey.lightf6};
      color: ${props.isActive ? props.theme.colors.white.base : props.theme.colors.grey.base};
      font-weight: ${props.isActive ? props.theme.font.fontWeight.black :props.theme.font.fontWeight.bold};
    `
);

export const HeaderStepText = styled.p(
    props => `
        padding-left: ${props.theme.spacing.base};
        font-size: ${props.theme.font.large.font14};
        color: ${props.isActive ? props.theme.colors.black.base : props.theme.colors.grey.base};
        font-weight: ${props.isActive ? props.theme.font.fontWeight.bold : ''};
    `
);
